import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import './merchantAgreementDocument.css'

const SCHEDULE_A_FIELDS = [
  'Agreement Version',
  'Merchant Specific Terms Version / Reference',
  'Merchant Account ID',
  'Merchant Legal Name',
  'Authorized User',
  'Registered Email',
  'Date and Time Accepted',
  'IP Address',
  'User Agent / Device Information',
] as const

type MerchantAgreementScheduleAField = typeof SCHEDULE_A_FIELDS[number]

export type MerchantAgreementScheduleAValues = Record<MerchantAgreementScheduleAField, string>

interface MerchantAgreementDocumentViewProps {
  markdownContent: string
  testId?: string
  scheduleAValues?: MerchantAgreementScheduleAValues
}

function nodeText(node: unknown): string {
  if (!node || typeof node !== 'object') return ''
  const value = 'value' in node ? node.value : undefined
  if (typeof value === 'string') return value
  const children = 'children' in node ? node.children : undefined
  return Array.isArray(children) ? children.map(nodeText).join('') : ''
}

export default function MerchantAgreementDocumentView({
  markdownContent,
  testId,
  scheduleAValues,
}: MerchantAgreementDocumentViewProps) {
  return (
    <article className="merchant-agreement-document" data-testid={testId}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={scheduleAValues ? {
          p: ({ node, ...props }) => {
            const text = nodeText(node)
            const field = SCHEDULE_A_FIELDS.find((candidate) => text.startsWith(candidate))
            if (!field || !text.includes('[●]')) return <p {...props} />

            return (
              <p data-agreement-schedule-field={field}>
                <strong>{field}:</strong> {scheduleAValues[field]}
              </p>
            )
          },
        } : undefined}
      >
        {markdownContent}
      </ReactMarkdown>
    </article>
  )
}
